import React from 'react';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';

const Voice = () => {
  const doneeVoices = [
    {
      name: 'Y.M',
      voice: 'ご協力していただいたドナーの皆様が誠実な方だったことが印象に残っています。提供後も体調を気遣うメッセージをいただくなど、とても安心して提供を受けることができました。'
    },
    {
      name: 'A.T',
      voice: '検索条件の項目が多く、自分が希望するドナーを簡単に見つけることができました。メッセージ機能も使いやすく、スムーズに提供を受けることができました。'
    },
    {
      name: 'K.L',
      voice: '2年にわたる不妊治療で夫婦ともに疲れ果てていました。Ton Bébéで知り合ったドナーの方にとても親切にしていただいて、無事に妊娠することができ、今は夫婦仲も戻って幸せです。'
    },
  ];

  const donorVoices = [
    {
      name: 'H.S',
      voice: '友人夫婦が不妊で悩んでいることがきっかけで登録しました。他にも悩んでいるご夫婦が多くいることを知り、自分で良ければ、という想いで登録しました。'
    },
    {
      name: 'K.H',
      voice: '困っている人の助けになればと思い登録しました。登録するとすぐにドニーの方からご連絡をいただき、自分でも人助けができることを実感しました。'
    },
    {
      name: 'T.K',
      voice: 'こどもを真剣にほしいと願う方の力になりたくて登録しました。サイトを通じて知り合ったドニーの方が無事に出産されたときは、自分のことのように嬉しかったです。'
    },
  ];

  const doneeVoiceItems = doneeVoices.map((d, i) => {
    return (
      <SwiperSlide key={ i } className="donnie_pink" tag="li">
        <h3>{ d.name }様<span>ドニー</span></h3>
        <p>{ d.voice }</p>
      </SwiperSlide>
    );
  });

  const donorVoiceItems = donorVoices.map((d, i) => {
    return (
      <SwiperSlide key={ i } className="donor_blue" tag="li">
        <h3>{ d.name }様<span>ドナー</span></h3>
        <p>{ d.voice }</p>
      </SwiperSlide>
    );
  });

  return (
    <section className="voice">
      <h2 className="sec_title donnie_pink">ご利用者様の声</h2>
      <div className="swiper donor_list donnie_pink" id="pink">
        <div className="swiper-container">
          <Swiper
            wrapperTag="ul"
            modules={[Autoplay]}
            breakpoints={{
              750: {
                slidesPerView: 2,
                spaceBetween: 40
              }
            }}
            spaceBetween={ 20 }
            slidesPerView={ 1 }
            autoplay={{ delay: 6000 }}
            loop={ true }
            speed={ 2000 }
          >
            { doneeVoiceItems }
          </Swiper>
        </div>
      </div>

      <div className="swiper donor_list donor_blue" id="blue">
        <div className="swiper-container">
          <Swiper
            wrapperTag="ul"
            modules={[Autoplay]}
            breakpoints={{
              750: {
                slidesPerView: 2,
                spaceBetween: 40
              }
            }}
            spaceBetween={ 20 }
            slidesPerView={ 1 }
            autoplay={{ delay: 6000 }}
            loop={ true }
            speed={ 2000 }
          >
            { donorVoiceItems }
          </Swiper>
        </div>
      </div>

    </section>
  );
}

export default Voice;
